import apiClient from './client';
import type { CreateNodePayload, UpdateNodePayload } from '@/types/node.types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ApiNode = any;

export const nodesApi = {
  listByCanvas: async (canvasId: string): Promise<ApiNode[]> => {
    const { data } = await apiClient.get<ApiNode[]>('/nodes', { params: { canvasId } });
    return data;
  },

  getById: async (nodeId: string): Promise<ApiNode> => {
    const { data } = await apiClient.get<ApiNode>(`/nodes/${nodeId}`);
    return data;
  },

  create: async (payload: CreateNodePayload): Promise<ApiNode> => {
    const { data } = await apiClient.post<ApiNode>('/nodes', payload);
    return data;
  },

  update: async (nodeId: string, payload: UpdateNodePayload): Promise<ApiNode> => {
    const { data } = await apiClient.patch<ApiNode>(`/nodes/${nodeId}`, payload);
    return data;
  },

  delete: async (nodeId: string): Promise<void> => {
    await apiClient.delete(`/nodes/${nodeId}`);
  },
};

export default nodesApi;
